import React from 'react';
import Tooltip from '../Tooltip';
import styles from './ColorDot.module.css';

export type ColorDotVariant =
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'primary'
  | 'waiting'
  | 'expired';

interface ColorDotProps {
  variant: ColorDotVariant;
  className?: string;
  title?: string;
  onClick?: () => void;
  'aria-label'?: string;
  'aria-expanded'?: boolean;
}

const ColorDot: React.FC<ColorDotProps> = ({
  variant,
  className = '',
  title,
  onClick,
  ...aria
}) => {
  const dotClassName = [styles.dot, styles[variant], className].filter(Boolean).join(' ');

  if (onClick) {
    return (
      <Tooltip content={title}>
        <button
          type="button"
          className={styles.button}
          onClick={onClick}
          aria-label={aria['aria-label']}
          aria-expanded={aria['aria-expanded']}
        >
          <span className={dotClassName} aria-hidden="true" />
        </button>
      </Tooltip>
    );
  }

  return (
    <Tooltip content={title}>
      <span
        className={dotClassName}
        aria-label={aria['aria-label']}
      />
    </Tooltip>
  );
};

export default ColorDot;
